import { BikeStation, ComputedRoute, Route } from '@geovelo-frontends/commons';
import { StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';

import SectionCard from './section-card';
import WayPointCard from './way-point-card';

const styles = StyleSheet.create({
  sectionWrapper: {
    marginTop: 30,
  },
});

interface IProps {
  bikeStationsMap: { [key: number]: BikeStation };
  route: ComputedRoute | Route;
}

function InstructionsList({ bikeStationsMap, route }: IProps): JSX.Element {
  return (
    <View>
      {route.sections.map((_, sectionIndex) => (
        <View key={sectionIndex} style={styles.sectionWrapper}>
          <WayPointCard
            bikeStationsMap={bikeStationsMap}
            route={route}
            sectionIndex={sectionIndex}
          />
          <SectionCard route={route} sectionIndex={sectionIndex} />
          {sectionIndex === route.sections.length - 1 && (
            <WayPointCard
              isArrival
              bikeStationsMap={bikeStationsMap}
              route={route}
              sectionIndex={sectionIndex}
            />
          )}
        </View>
      ))}
    </View>
  );
}

export default InstructionsList;
